import { Component } from 'san';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import organizationService from 'src/services/organization.service';
import dialogService from 'src/services/dialog.service';
import { IOrganization } from 'src/models';
import axios from 'axios';
import toasterService from 'src/services/toaster.service';

const LEVEL_OFFSET = 24;

declare function currentPagePathAndQuery();

export default class OrganizationsListTree extends Component {
    constructor(options: any) {
        super(options);
    }

    initData() {
        return {
            items: [],
            checkedItem: null,
            q: '',
            searchQ$: new Subject<string>(),
        };
    }

    inited() {
        this.getOrganizations();
        this.data
            .get('searchQ$')
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(() => {
                this.search();
            });
        this.watch('q', (value) => {
            this.data.get('searchQ$').next(value);
        });
    }

    check(item: IOrganization) {
        this.data.set('checkedItem', item);
        this.dispatch('UI:organization-tree-changed', item);
    }

    toDetail(item: IOrganization) {
        const returnUrl = encodeURIComponent(currentPagePathAndQuery());
        const href = `/pages/user/system/org-detail/${item.org_number}`;
        window.location.href = `${href}?returnUrl=${returnUrl}`;
    }

    toStop(item: IOrganization) {
        // 父级组织禁用后，子组织需一起禁用
        dialogService.show({
            title: '提示',
            content: '您确定要禁用吗？',
            confirmCallback: () => {
                organizationService.getAllChildrenOrganizations(item.org_number).then((children) => {
                    const enabledChildren = _.filter(children, { org_status: 1 });
                    const childrenOrgNumbers = _.map(enabledChildren, 'org_number');
                    const requests = [organizationService.toggleEnableOrganization(item.org_number)];
                    _.forEach(childrenOrgNumbers, org_number=> {
                        requests.push(organizationService.toggleEnableOrganization(org_number))
                    });
                    axios.all(requests).then(() => {
                        window.location.reload();
                    })
                });
            },
        });
    }

    toStart(item: IOrganization) {
        // 父级部门启用后，子部门不一起启用
        // 父级部门处于禁用状态时，子部门不允许启用
        dialogService.show({
            title: '提示',
            content: '您确定要启用吗？',
            confirmCallback: () => {
                const items = this.data.get('items');
                if (item.parent_org_number) {
                    const parentOrg = _.find(items, {org_number: item.parent_org_number} );
                    if (parentOrg && 0 === parentOrg.org_status) {
                        toasterService.show({ type: 'danger', title: `${item.org_name}的上级部门为禁用状态，${item.org_name}不可启用` });
                        return;
                    }
                }
                organizationService.toggleEnableOrganization(item.org_number).then(() => {
                    window.location.reload();
                })
            },
        });
    }

    toAddChildOrg(item: IOrganization) {
        const returnUrl = encodeURIComponent(currentPagePathAndQuery());
        const href = `/pages/user/system/org-add?parent_org_number=${item.org_number}`;
        window.location.href = `${href}&returnUrl=${returnUrl}`;
    }

    toEdit(item: IOrganization) {
        const returnUrl = encodeURIComponent(currentPagePathAndQuery());
        const href = `/pages/user/system/org-edit/${item.org_number}`;
        window.location.href = `${href}?returnUrl=${returnUrl}`;
    }

    toAddOrg() {
        const returnUrl = encodeURIComponent(currentPagePathAndQuery());
        const href = `/pages/user/system/org-add`;
        window.location.href = `${href}?returnUrl=${returnUrl}`;
    }

    search() {
        this.getOrganizations(this.data.get('q'));
    }

    toggleExpand(item: IOrganization) {
        const items = this.data.get('items');
        const index = _.findIndex(items, { org_number: item.org_number });
        item = items[index];
        item._is_expand = !item._is_expand;
        if (item._is_expand) {
            if (item._has_loaded_children) {
                this.showOrHideChildren(items, item, true);
                this.data.splice('items', [0, items.length, ...items]);
                return;
            }
            item._has_loaded_children = true;
            this.data.splice('items', [index, 1, item]);
            this.getChildrenOrganizations(item);
        } else {
            this.showOrHideChildren(items, item, false);
            this.data.splice('items', [0, items.length, ...items]);
        }
    }

    private showOrHideChildren(items: IOrganization[], item: IOrganization, isShow: boolean) {
        const children: IOrganization[] = _.filter(items, { parent_org_number: item.org_number });
        _.forEach(children, (child) => {
            child._is_show = isShow;
            if (child._is_expand && child.has_children) {
                this.showOrHideChildren(items, child, isShow);
            }
        });
    }

    getOrganizations(q?: string) {
        organizationService.getOrganizations(q, true).then((organizations) => {
            const items = this.data.get('items');
            this.data.splice('items', [0, items.length, ...organizations]);
        });
    }

    // 获取子组织
    getChildrenOrganizations(organization: IOrganization) {
        organizationService.getChildrenOrganizations(organization.org_number).then((children) => {
            _.forEach(children, (item) => {
                item._level = organization._level + 1;
                item._is_show = true;
                item._is_expand = false;
                item._has_loaded_children = false;
            });
            const items = this.data.get('items');
            const index = _.findIndex(items, { org_number: organization.org_number });
            this.data.splice('items', [index + 1, 0, ...children]);
        });
    }

    // 计算缩进量
    getLeftOffset(item: IOrganization): string {
        return 'margin-left:' + item._level * LEVEL_OFFSET + 'px';
    }
}
